import { CubeQuery } from '@/types/cube';
import { resolveCountryFilters } from '@/utils/cube/resolveCountryFilters';
import { CubejsApi, Filter, TimeDimension } from '@cubejs-client/core';
import replaceSqlAliases from './replaceSqlAliases';

export type GetTranslatedCubeQueryIntoSQLParams = {
  globalFilterApplied: Filter[];
  baseQuery: CubeQuery;
  cubejsApiCallback: CubejsApi;
  translationsMap: Record<string, string>;
  dateRange?: TimeDimension;
  additionalQueryParser?: (query: string) => string;
};

type TranslatedSQLobject = {
  sql: string;
  values: string[];
};

export const BASE_DOWNLOAD_DATA_LIMIT = 50000;
export const EXTENDED_DOWNLOAD_DATA_LIMIT = 700000;

export const getTranslatedCubeQueryIntoSQL = async ({
  globalFilterApplied = [],
  cubejsApiCallback,
  baseQuery,
  translationsMap,
  dateRange,
  additionalQueryParser,
}: GetTranslatedCubeQueryIntoSQLParams): Promise<TranslatedSQLobject> => {
  const filters = [...globalFilterApplied];

  const assembled = {
    ...baseQuery,
    filters,
    timeDimensions: dateRange ? [dateRange] : [],
  };

  const query = resolveCountryFilters(assembled, filters);

  const sqlResult = await cubejsApiCallback.sql(query);
  let [translatedQueryInSQL, valuesToExchange] = sqlResult.rawQuery().sql;

  valuesToExchange = valuesToExchange.map(valueToExchange => String(valueToExchange).replace(/'/g, '%27'));

  for (let index = valuesToExchange.length; index >= 0; index--) {
    translatedQueryInSQL = translatedQueryInSQL.replaceAll(`$${index}`, `'${valuesToExchange[index - 1]}'`);
  }

  translatedQueryInSQL = translatedQueryInSQL.replaceAll("'", "\''").replaceAll('%27', "''''");

  if ('limit' in query && query.limit === BASE_DOWNLOAD_DATA_LIMIT) {
    translatedQueryInSQL = translatedQueryInSQL.replaceAll(`${query.limit}`, EXTENDED_DOWNLOAD_DATA_LIMIT.toString());
  }

  if (additionalQueryParser) {
    translatedQueryInSQL = additionalQueryParser(translatedQueryInSQL);
  }

  return {
    sql: replaceSqlAliases(translatedQueryInSQL, translationsMap),
    values: valuesToExchange,
  };
};
